export const PASSWORD_REQUIREMENTS_TEXT = 'Password must be at least 10 characters and include uppercase, lowercase and a number.';

export function getPasswordRequirementState(password = '') {
  const value = typeof password === 'string' ? password : '';
  return [
    { key: 'length', label: 'At least 10 characters', met: value.length >= 10 },
    { key: 'uppercase', label: 'One uppercase letter', met: /[A-Z]/.test(value) },
    { key: 'lowercase', label: 'One lowercase letter', met: /[a-z]/.test(value) },
    { key: 'number', label: 'One number', met: /[0-9]/.test(value) },
  ];
}

export function passwordMeetsRequirements(password = '') {
  return getPasswordRequirementState(password).every((requirement) => requirement.met);
}
